import { render, staticRenderFns } from "./TeacherManageView.vue?vue&type=template&id=3748a08b&scoped=true"
import script from "./TeacherManageView.vue?vue&type=script&lang=js"
export * from "./TeacherManageView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3748a08b",
  null
  
)

export default component.exports